/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getClickRecipe } from "../../../redux/actions/analytics";
import { formatDate } from "../helper";
import Spinner from "../../Spinner";

const CouponRecipe = ({ startDate, endDate }) => {
  const dispatch = useDispatch();
  const recipeloading = useSelector(
    (state) => state.analytics.clickrecipe_loading
  );
  const recipe = useSelector((state) => state.analytics.clickrecipe);

  useEffect(() => {
    if (startDate !== "" && endDate !== "") {
      const skip = 0;
      const limit = 50;
      dispatch(
        getClickRecipe(formatDate(startDate), formatDate(endDate), limit, skip)
      );
    }
  }, []);

  useEffect(() => {
    if (startDate !== "" && endDate !== "") {
      const skip = 0;
      const limit = 50;
      dispatch(
        getClickRecipe(formatDate(startDate), formatDate(endDate), limit, skip)
      );
    }
  }, [startDate, endDate]);

  return (
    <div className="w-full flex flex-col items-center">
      <div>
        {recipeloading && <Spinner />}
        {!recipeloading && recipe.length !== 0 && (
          <div>
            <table>
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Product/Service</th>
                  <th>Screen</th>
                  <th>Clicked</th>
                  <th>Percentage (click / all click)</th>
                  <th>Uniq</th>
                </tr>
              </thead>
              <tbody>
                {recipe.screens.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.companyname}</td>
                      <td>{item.product}</td>
                      <td>{item.screen}</td>
                      <td>{item.pressed}</td>
                      <td>{item.percentage} %</td>
                      <td>{item.userid.length}</td>
                    </tr>
                  );
                })}
                <tr className="font-bold">
                  <td>SUM</td>
                  <td />
                  <td />
                  <td>{recipe.total}</td>
                  <td />
                  <td>{recipe.uniq}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CouponRecipe;
